import {
    LOAD_API_COMMENT_DATA,
    LOAD_API_COMMENT_DATA_FAILED,
    LOAD_API_COMMENT_DATA_SUCCESS,
  } from "../types"
  
  const initialState = {
    comments: [],
    loading: false,
    error: false,
  }
  
  export default function (state = initialState, action) {
    switch (action.type) {
      case LOAD_API_COMMENT_DATA:
        return {
          ...state,
          loading: true,
          error: false,
          comments: []
        }
      case LOAD_API_COMMENT_DATA_FAILED:
        return {
          ...state,
          loading: false,
          error: true,
          comments: []
        }
      case LOAD_API_COMMENT_DATA_SUCCESS:
        return {
          ...state,
          loading: false,
          error: false,
          comments: action.payload
        }
      default:
        return state
    }
  }
  